import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const ExpandableCellButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacings.X_SMALL};
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
`;

export const ExpandableCellText = styled.span<{ $isExpanded: boolean }>`
  display: block;
  flex: 1 1 auto;
  max-width: 100%;
  min-width: 0;
  overflow: ${({ $isExpanded }) => ($isExpanded ? 'visible' : 'hidden')};
  white-space: ${({ $isExpanded }) => ($isExpanded ? 'normal' : 'nowrap')};
  text-overflow: ${({ $isExpanded }) => ($isExpanded ? 'clip' : 'ellipsis')};
`;

export const StaticCellText = styled.span`
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ExpandableCellIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  color: ${theme.light.text.staticIconsTertiary};
`;
